import { format } from 'date-fns';

interface FormatValueOptions {
  fractionDigits?: number;
  nullFallback?: string;
}

interface FormatFallbackOptions {
  nullFallback?: string;
}

export function formatUsd(value: number | null, options: FormatValueOptions = {}): string {
  const { fractionDigits = 2, nullFallback = 'No usage' } = options;
  if (value === null) return nullFallback;

  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatNumber(value: number | null, options: FormatValueOptions = {}): string {
  const { fractionDigits = 2, nullFallback = 'No usage' } = options;
  if (value === null) return nullFallback;

  return value.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatPercent(value: number | null, options: FormatValueOptions = {}): string {
  const { fractionDigits = 2, nullFallback = 'No usage' } = options;
  if (value === null) return nullFallback;

  return `${formatNumber(value * 100, { fractionDigits })}%`;
}

export function formatAvgCostPerCall(value: number | null, options: FormatFallbackOptions = {}): string {
  return formatUsd(value, { ...options, fractionDigits: 4 });
}

export function formatDate(value: string): string {
  return new Date(value).toLocaleDateString('en-US');
}

export function formatDateTime(value: string): string {
  return new Date(value).toLocaleString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function formatUpdatedInfo(updatedAt?: string, updatedBy?: string): string {
  if (!updatedAt) return '—';
  const dateStr = format(new Date(updatedAt), 'yyyy.MM.dd');
  return updatedBy ? `${dateStr} by ${updatedBy}` : dateStr;
}
